<script setup lang="ts">
import { ElDrawer, ElDivider } from "element-plus";
import DrawerHeaderIcons from "@/components/common/DrawerHeaderIcons/DrawerHeaderIcons.vue";
import AddVisitorTimelineForm from "./AddVisitorTimelineForm.vue";
import { useI18n } from "vue-i18n";

export interface Props {
  visible: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  (e: "close"): void;
  (e: "created"): void;
}>();

const { t } = useI18n();
</script>

<template>
  <el-drawer
    :model-value="visible"
    direction="rtl"
    size="100%"
    :with-header="false"
    destroy-on-close
    close-on-click-modal
    close-on-press-escape
    @closed="emit('close')"
  >
    <DrawerHeaderIcons
      hide-arrows
      @close="emit('close')"
    />
    <h2>{{ t("visitors.timeline.actions.signInVisitor") }}</h2>
    <el-divider />
    <AddVisitorTimelineForm @created="emit('close')" />
  </el-drawer>
</template>

<style lang="scss" scoped>
h2 {
  margin: 30px 0 20px;
}
</style>
